






module.exports =
  props:
    text: { required: true }
    color: { default: '#000' }




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/text_image.vue